module.exports = __webpack_public_path__ + "media/images/icon/icons8-Unchecked Checkbox-41700e74597d2016793435d3eec9a849.png";